var _require = require('./transaction-types'),
  formatSlipTypeName = _require.formatSlipTypeName;
var UTXO_KEY_BYTE_LENGTH = 59;
var UTXO_KEY_HEX_LENGTH = UTXO_KEY_BYTE_LENGTH * 2;
function normalizeUtxoKeyHex() {
  var raw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = String(raw || '').trim();
  if (value.startsWith('0x') || value.startsWith('0X')) {
    value = value.slice(2);
  }
  return value.toLowerCase();
}
function isUtxoKeyHex() {
  var raw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var hex = normalizeUtxoKeyHex(raw);
  return /^[0-9a-f]+$/.test(hex) && hex.length === UTXO_KEY_HEX_LENGTH;
}
function hexToBytes(hex) {
  var bytes = [];
  for (var i = 0; i < hex.length; i += 2) {
    bytes.push(parseInt(hex.slice(i, i + 2), 16));
  }
  return bytes;
}
function readUint64Be(bytes, offset) {
  var value = 0n;
  for (var i = 0; i < 8; i++) {
    value = (value << 8n) + BigInt(bytes[offset + i]);
  }
  return value;
}
function bytesToHex(bytes) {
  return bytes.map(function (_byte) {
    return _byte.toString(16).padStart(2, '0');
  }).join('');
}
function parseUtxoKeyHex() {
  var raw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var hex = normalizeUtxoKeyHex(raw);
  if (!isUtxoKeyHex(hex)) {
    return null;
  }
  var bytes = hexToBytes(hex);
  var publicKeyHex = bytesToHex(bytes.slice(0, 33));
  var blockId = readUint64Be(bytes, 33);
  var txOrdinal = readUint64Be(bytes, 41);
  var slipIndex = bytes[49];
  var amount = readUint64Be(bytes, 50);
  var slipType = bytes[58];
  return {
    utxokey: hex,
    publicKeyHex: publicKeyHex,
    blockId: blockId,
    txOrdinal: txOrdinal,
    slipIndex: slipIndex,
    amount: amount,
    slipType: slipType,
    slipTypeName: formatSlipTypeName(slipType)
  };
}
module.exports = {
  UTXO_KEY_BYTE_LENGTH: UTXO_KEY_BYTE_LENGTH,
  UTXO_KEY_HEX_LENGTH: UTXO_KEY_HEX_LENGTH,
  normalizeUtxoKeyHex: normalizeUtxoKeyHex,
  isUtxoKeyHex: isUtxoKeyHex,
  parseUtxoKeyHex: parseUtxoKeyHex
};